<template>
  <el-dialog
    :visible.sync="show"
    custom-class="dialog"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    >
    <div class="first-floor">
      <div class="label">
        <el-input v-model="form.name" placeholder="请输入姓名" :disabled="isSecond"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11" :disabled="isSecond"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <el-input v-model="form.address" placeholder="请输入所在地区" :disabled="isSecond"></el-input>
      </div>
    </div>
    <div v-if="!isSecond" class="submit-box">
      <el-button class="loginBtn" type="success" @click="submit">提交</el-button>
      <el-button class="loginBtn cancel" type="success" @click="closeDialog">取消</el-button>
    </div>
    <div v-else class="submit-box">
      <el-button class="loginBtn cancel" type="success" @click="isSecond = false">修改</el-button>
      <el-button class="loginBtn" type="success" :loading="isloading" @click="handleEdit">{{isloading ? '确认...' : '确认'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isPhone } from '@/util/utils.js'
import axios from 'axios'
const md5 = require('js-md5')
export default {
  name: 'renewBooking',
  components:{ 
  },
  props: {
    show: false,
    info: {
      type: Object
    }
  },
  data() {
    return {
      dialogVisible: true,
      form: {
        name: '',
        mobile: '',
        address: ''
      },
      isSecond: false,
      isClickEdit: false,
      isloading: false
    }
  },
  computed:{ },
  watch:{
    // isneedLogin(olddata, newdata) {
    //   if (olddata != newdata) {
    //     this.form = {
    //       mobile: '',
    //       sms_code: ''
    //     }
    //     this.validation = ''
    //     this.refreshCode()
    //   }
    // }
  },
  created() {
    this.form = {...this.info}
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    handleCity(data) {
      console.log('handleCity', data)
      const obj = this.cityList.filter(item => item.value === data[0])[0]
      this.ruleForm.province = obj.label
      const obj1 = obj.children.filter(item => item.value === data[1])[0]
      this.ruleForm.city = obj1.label === '市辖区' ? obj.label : obj1.label
    },
    submit() {
      if (!isPhone(this.form.mobile)) {
        this.$message('请输入手机号')
        return
      }
      if (!this.form.name) {
        this.$message('请输入姓名')
        return
      }
      if (!this.form.address) {
        this.$message('请输入所在地区')
        return
      }
      this.isSecond = true
    },
    handleEdit() {
      if (this.isClickEdit) {
        return false
      }
      this.isClickEdit = true
      if (!isPhone(this.form.mobile)) {
        this.$message('请输入手机号')
        this.isClickEdit = false
        return
      }
      if (!this.form.name) {
        this.$message('请输入姓名')
        this.isClickEdit = false
        return
      }
      if (!this.form.address) {
        this.$message('请输入所在地区')
        this.isClickEdit = false
        return
      }
      const stamp = Date.now()
      const user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
      const open_id = JSON.parse(localStorage.getItem('giftsUser')).open_id || ''
      const token = localStorage.getItem('token')
      const key = atob(localStorage.getItem('key'))
      const { name, mobile, address, id } = this.form
      const sign = md5(`${stamp}${token}${id}${user_id}${key}`)
      axios.post('/interface/updateBooking',
        {
          booking_id: id,
          name,
          mobile,
          address,
          open_id,
          user_id,
          token,
          stamp,
          sign
        }
      ).then(res=> {
        if (res.data.result === 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('refresh')
          this.$emit('close')
        } else {
          this.$message(res.data.msg)
          this.isClickEdit = false
        }
      }).catch((err) => {
        this.isClickEdit = false
        console.log(err)
      })
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog {
  width: 720px;
  position: absolute;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 61px 50px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    .first-floor {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      .label {
        flex: 1;
        height: 50px;
        padding: 0 10px;
        border: 1px solid #B8D4B4;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-input__inner {
          border: 0;
          outline: none;
          font-size: 18px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #000;
        }
        .el-cascader {
          width: 100%;
        }
      }
    }
    .submit-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 60px;
      .loginBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 291px;
        height: 58px;
        background: #4E8B46;
        border-radius: 25px 25px 25px 25px;
        border: 1px solid #4E8B46;
        font-size: 32px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto 19px auto;
        cursor: pointer;
        -webkit-user-select: none;
        .el-icon-loading {
          font-size: 32px!important;
        }
        &.cancel {
          color: #4E8B46;
          background: #fff;
        }
      }
    }
  }
}
</style>